"use client"

import { useState, useEffect } from "react"
import { Button } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMicrosoft } from "@fortawesome/free-brands-svg-icons"
import { useMsal } from "@azure/msal-react"
import { useNavigate } from "react-router-dom"
import { loginMicrosoft, clearPendingInteractions } from "../../Auth/AuthMicrosoft/authMicrosoft"
import { devError, devWarn } from "../../utils/devConsole"


const MicrosoftButton = () => {
  const { instance } = useMsal()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [isReady, setIsReady] = useState(false)

  // Pulire le interazioni al caricamento del componente SOLO se l'utente era connesso con Microsoft
  useEffect(() => {
    const initButton = async () => {
      try {
        const authMethod = localStorage.getItem("authMethod");
        if (authMethod === "microsoft") {
          await clearPendingInteractions(instance)
        }
        setIsReady(true)
      } catch (error) {
        devWarn("Error during button initialization:", error)
        setIsReady(true) // Permettere comunque l'utilizzo del pulsante
      }
    }

    initButton()
  }, [instance])

  const handleMicrosoftLogin = async () => {
    if (!isReady || isLoading) return

    setIsLoading(true)
    try {
      await loginMicrosoft(instance, navigate)
    } catch (error) {
      devError("Error during Microsoft authentication:", error)
      // Mostrare un messaggio all'utente
      if (error.message.includes("interaction_in_progress")) {
        alert("An authentication is already in progress. Please try again in a few moments.")
        // Tentare di pulire le interazioni
        await clearPendingInteractions(instance)
      }
    } finally {
      // Ritardo prima di riattivare il pulsante per evitare clic multipli
      setTimeout(() => {
        setIsLoading(false)
      }, 2000)
    }
  }

  return (
    <Button
      variant="outline-dark"
      onClick={handleMicrosoftLogin}
      className="m-2"
      disabled={isLoading || !isReady} // Disabilita il pulsante durante la connessione o se non pronto
    >
      <FontAwesomeIcon icon={faMicrosoft} className="me-2" />
      {isLoading ? "Loading..." : "Continua con Microsoft"}
    </Button>
  )
}

export default MicrosoftButton
